export enum FeedbackServiceEnum {
  MinSide = 'MinSide',
  MinBedrift = 'MinBedrift',
  IceGateway = 'IceGateway',
  Diego = 'Diego',
}

export enum FeedbackType {
  ErrorBattlecards = 'ErrorBattlecards',
  FeatureFeedback = 'FeatureFeedback',
  GeneralFeedback = 'GeneralFeedback',
}

export class Feedback {
  /** Min Side, Min Bedrift, the app (Ice Gateway) or Diego */
  service!: FeedbackServiceEnum;
  /** Feedback text */
  text!: string;
  /** A rating between 1 and 4 */
  rating!: number;
  /** Whether the user consent to be contacted regarding the feedback */
  canBeContacted!: boolean;
  /** User ID */
  userId?: string;
  /** Version number of the Self Service frontend or the app */
  clientVersion?: string;
  /** Self Service API version */
  apiVersion?: string;
  /** Device manufacturer (Apple, Samsung etc.) */
  deviceManufacturer?: string;
  /** Device model (iPhone, Galaxy S9 etc.) */
  deviceModel?: string;
  /** Device language */
  deviceLanguage?: string;
  /** Device OS */
  deviceOperatingSystem?: string;
  /** Device OS version */
  deviceOperatingSystemVersion?: string;
  /** Browser */
  browser?: string;
  /** User agent string */
  userAgent?: string;
  /** Viewport width */
  viewportWidth?: number;
  /** Viewport height */
  viewportHeight?: number;
  /** Application Insights user ID */
  appInsightsUserId?: string;
  /** Order id */
  orderId?: string;
  /** Dealer id */
  dealerId?: string;
  /** Dealer name */
  dealerName?: string;
  /** Feedback type */
  feedbackType: FeedbackType;
  /** Contact email */
  contactEmail?: string;
}
